export const SMS = 'SMS';
export const smsTags = ['Sms'];
